{
  "categories": {
    "certificates": "Certificati",
    "dashboard": "Dashboard",
    "dataTransfer": "Trasferimento dati",
    "other": "Altro",
    "products": "Prodotti",
    "suppliers": "Fornitori"
  },
  "title": "FAQ"
}
